import { configureStore, Store, Middleware } from '@reduxjs/toolkit';
import { createEpicMiddleware } from 'redux-observable';
import { routerMiddleware } from 'connected-react-router';
import { persistStore } from 'redux-persist';
import history from '../../history';
import rootReducer from '../reducers/rootReducer/rootReducer';
import rootEpic from '../middleware/root/rootEpic';
import {
    clearClaimInfoLinkList,
    setClaimInfoLinkList,
    setErrorMessage,
    setLoadingModalFlagAction,
} from '../reducers/actions';
import { buildClaimInfoLinkList } from '../middleware/claim/converters/buildClaimInfoLinkList';

const epicMiddleware = createEpicMiddleware({
    dependencies: {
        setErrorMessage,
        setClaimInfoLinkList,
        buildClaimInfoLinkList,
        clearClaimInfoLinkList,
        setLoadingModalFlagAction,
    },
});

export const createStore = (): Store =>
    configureStore({
        middleware: (getDefaultMiddleware: any) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [
                        'persist/PERSIST',
                        'persist/REHYDRATE',
                        'persist/PAUSE',
                        'persist/PURGE',
                        'persist/FLUSH',
                        'persist/REGISTER',
                    ],
                },
            }).concat(routerMiddleware(history) as Middleware, epicMiddleware as unknown as Middleware),
        reducer: rootReducer,
    });

export const store = createStore();

epicMiddleware.run(rootEpic);

export const persistor = persistStore(store);
